import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLanguage } from '@/shared/actions';
import { getLanguage } from '@/services/GNRL';

const useRouteLanguage = ({ queryLang, selectedLanguage }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!queryLang) return;
    if (selectedLanguage === queryLang) return;

    dispatch(setLanguage(queryLang));
  }, [dispatch, queryLang, selectedLanguage]);

  return queryLang || selectedLanguage || getLanguage() || 'en';
};

export default useRouteLanguage;
